import { useEffect, useState } from "react";
import { useLang } from "../context/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { type: "operation", title: "", body: "", name: "", date_label: "" };

export default function ResultsAdmin() {
  const { t } = useLang();
  const n = t("nx.results");
  const [items, setItems] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [busy, setBusy] = useState(false);

  const load = () => fetch(`${API}/results`).then((r) => (r.ok ? r.json() : Promise.reject())).then(setItems).catch(() => setItems([]));
  useEffect(() => { load(); }, []); // eslint-disable-line

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await fetch(`${API}/results`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        credentials: "include", body: JSON.stringify(form),
      });
      if (res.ok) { setForm(EMPTY); load(); }
    } catch {}
    setBusy(false);
  };

  const remove = async (id) => {
    await fetch(`${API}/results/${id}`, { method: "DELETE", credentials: "include" });
    load();
  };

  return (
    <div data-testid="admin-results">
      <form onSubmit={save} className="border border-white/10 p-6 md:p-8 mb-10" data-testid="results-admin-form">
        <div className="eyebrow mb-6">{n.adminAdd}</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5">
          <div>
            <label className="field-label" htmlFor="result-type">{n.f_type}</label>
            <select id="result-type" className="field-input cursor-pointer" value={form.type} data-testid="input-result-type"
              onChange={(e) => setForm({ ...form, type: e.target.value })}>
              <option value="operation">{n.typeOperation}</option>
              <option value="review">{n.typeReview}</option>
            </select>
          </div>
          <div>
            <label className="field-label" htmlFor="result-title">{n.f_title} *</label>
            <input id="result-title" className="field-input" required data-testid="input-result-title"
              value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          </div>
          <div className="md:col-span-2">
            <label className="field-label" htmlFor="result-body">{n.f_body}</label>
            <textarea id="result-body" rows={3} className="field-input" data-testid="input-result-body"
              value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} />
          </div>
          <div>
            <label className="field-label" htmlFor="result-name">{n.f_name}</label>
            <input id="result-name" className="field-input" data-testid="input-result-name"
              value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          </div>
          <div>
            <label className="field-label" htmlFor="result-date">{n.f_date}</label>
            <input id="result-date" className="field-input" placeholder="e.g. 01 / 2026" data-testid="input-result-date"
              value={form.date_label} onChange={(e) => setForm({ ...form, date_label: e.target.value })} />
          </div>
        </div>
        <button type="submit" disabled={busy} className="btn btn-solid !py-2.5 !px-6 mt-6" data-testid="result-save-btn">{n.adminAdd}</button>
      </form>

      {items === null && <p className="mono text-[12px] text-[#666663]">…</p>}
      {items && items.length === 0 && <p className="mono text-[12px] text-[#666663]" data-testid="results-admin-empty">{n.adminNone}</p>}
      {(items || []).map((r) => (
        <div key={r.id} className="border border-white/10 p-4 mb-3 flex items-start justify-between gap-4" data-testid="results-admin-row">
          <div>
            <div className="mono text-[9px] tracking-[0.2em] text-[#D1C7BD] uppercase">{r.type === "review" ? n.typeReview : n.typeOperation}</div>
            <div className="mono text-[12px] text-[#F3F3F0] mt-1">{r.title}</div>
            {r.body && <p className="text-[12px] text-[#999995] mt-1">{r.body}</p>}
          </div>
          <button onClick={() => remove(r.id)} className="btn !py-2 !px-4 shrink-0" data-testid={`result-delete-${r.id}`}>{n.adminDelete}</button>
        </div>
      ))}
    </div>
  );
}
